module.exports = __webpack_public_path__ + "images/[6]1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[6]1.jpeg
// module id = 37
// module chunks = 0